import { PermissionEnum } from "@rms-types/modules/permission/enum";
import { Suspense } from "react";

import { AppRoute } from "../types";

import { useUserStore } from "@/hooks";
import { Error403 } from "@/components";

const getHasPermissionForPage = ({
  pagePermissions = [],
  permissionsForPage = [],
}: {
  pagePermissions: PermissionEnum[];
  permissionsForPage: PermissionEnum[];
}) => {
  return (
    pagePermissions.length === 0 ||
    pagePermissions.some(
      (p) => permissionsForPage.includes(p) || permissionsForPage.includes(PermissionEnum.ADMIN_ACCESS)
    )
  );
};

export function RouteElement({ pageRoute }: { pageRoute: AppRoute }) {
  const { permissionTypes } = useUserStore();

  const hasPermissionForPage = getHasPermissionForPage({
    pagePermissions: pageRoute.permissions ?? [],
    permissionsForPage: permissionTypes,
  });

  if (!hasPermissionForPage || pageRoute.disabled) {
    return <Error403 />;
  }

  const Page = pageRoute.page;

  return (
    <Suspense>
      <Page />
    </Suspense>
  );
}
